module.exports = __webpack_public_path__ + "static/media/get_50pt.fd74ef86.png";